import React from 'react';
import { UserX, FileX, Clock, Layout, AlertTriangle } from 'lucide-react';
import { content } from '../data/content';

const PainPoints: React.FC = () => {
  const { painPoints } = content;

  // Icons mapping for the cards
  const getIcon = (index: number) => {
    switch (index) {
      case 0: return <UserX className="w-8 h-8" />;
      case 1: return <FileX className="w-8 h-8" />;
      case 2: return <Clock className="w-8 h-8" />;
      case 3: return <Layout className="w-8 h-8" />;
      default: return <UserX className="w-8 h-8" />;
    }
  };

  // Metallic Frosted Glass Style
  const metallicGlassStyle = "bg-gradient-to-br from-white/90 via-gray-50/80 to-gray-100/90 backdrop-blur-xl border border-white/60 shadow-[0_8px_30px_rgba(0,0,0,0.04)] ring-1 ring-white/80 hover:shadow-[0_20px_40px_rgba(0,0,0,0.08)] hover:bg-white transition-all duration-500";

  return (
    <section className="min-h-screen flex items-center justify-center py-24 bg-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-red-50/50 to-transparent -z-10"></div>
      <div className="absolute bottom-0 left-0 w-1/3 h-full bg-gradient-to-r from-gray-50/80 to-transparent -z-10"></div>

      <div className="container mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-20 max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-red-50 text-red-600 font-semibold text-sm mb-6 animate-fade-in-up">
            <AlertTriangle size={16} />
            <span>现状诊断</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-8 tracking-tight text-gray-900 animate-fade-in-up delay-100">
            {painPoints.title}
          </h2>
          <p className="text-xl md:text-2xl font-medium text-gray-600 animate-fade-in-up delay-200">
            真正的问题不是团队不努力，而是<br className="md:hidden" />
            <span className="text-red-600 font-bold bg-red-50 px-2 py-1 rounded mx-1">缺少“可执行的生产机制”</span>
          </p>
        </div>
        
        {/* Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {painPoints.mainIssue.items.map((item, index) => (
            <div 
              key={index} 
              className={`${metallicGlassStyle} p-8 rounded-2xl group animate-fade-in-up hover:-translate-y-2`}
              style={{ animationDelay: `${300 + index * 100}ms` }}
            >
              <div className="w-16 h-16 bg-gray-50 rounded-2xl flex items-center justify-center text-gray-400 mb-6 group-hover:bg-red-50 group-hover:text-red-500 transition-colors duration-300 shadow-inner">
                {getIcon(index)}
              </div>
              <h3 className="text-xl font-bold mb-4 text-gray-900 group-hover:text-red-600 transition-colors">{item.title}</h3>
              <p className="text-gray-500 leading-relaxed text-sm">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PainPoints;